const setWorkAddress= (val = null) => {
  return {
    type: 'SET_WORKADDRESS',
    data: val,
  }
}
const setWorkNumber = (val = null) => {
  return {
    type: 'SET_WORKNUMBER',
    data: val,
  }
}

const setWorkVillageName = (val = null) => {
  return {
    type: 'SET_WORKVILLAGENAME',
    data: val,
  }
}

const setWorkVillage = (val = null) => {
  return {
    type: 'SET_WORKVILLAGE',
    data: val,
  }
}

const setWorkFloor = (val = null) => {
  return {
    type: 'SET_WORKFLOOR',
    data: val,
  }
}

const setWorkRoad = (val = null) => {
  return {
    type: 'SET_WORKROAD',
    data: val,
  }
}

const setWorkProvince = (id = null, val = null) => {
  return {
    type: 'SET_WORKPROVINCE',
    id,
    data: val,
  }
}

const setWorkDistrict = (id = null, val = null) => {
  return {
    type: 'SET_WORKDISTRICT',
    id,
    data: val,
  }
}

const setWorkSubDistrict = (id = null, val = null) => {
  return {
    type: 'SET_WORKSUBDISTRICT',
    id,
    data: val,
  }
}

const setWorkZipcode = (val = null) => {
  return {
    type: 'SET_WORKZIPCODE',
    data: val,
  }
}

export default {
  setWorkAddress,
  setWorkNumber,
  setWorkVillageName,
  setWorkVillage,
  setWorkFloor,
  setWorkRoad,
  setWorkProvince,
  setWorkDistrict,
  setWorkSubDistrict,
  setWorkZipcode
}
